const sortCustom = document.querySelector('.collection__sort-custom');
const trigger = sortCustom?.querySelector('.collection__sort-trigger');
const dropdown = sortCustom?.querySelector('.collection__sort-dropdown');
const currentLabel = sortCustom?.querySelector('.collection__sort-current');
const nativeSelect = document.getElementById('js-collection-sorting');

if (sortCustom && trigger && dropdown) {
  const setOpen = (open) => {
    sortCustom.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', String(open));
  };

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    setOpen(!sortCustom.classList.contains('is-open'));
  });

  dropdown.addEventListener('click', (e) => {
    e.stopPropagation();
    const option = e.target.closest('[data-value]');
    if (!option) return;

    currentLabel.textContent = option.textContent.trim();

    dropdown.querySelectorAll('[data-value]').forEach((el) => {
      const selected = el === option;
      el.classList.toggle('collection__sort-option--current', selected);
      el.toggleAttribute('aria-selected', selected);
    });

    if (nativeSelect) {
      nativeSelect.value = option.dataset.value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setOpen(false);
  });

  document.addEventListener('click', () => setOpen(false));
}
